import React, { useEffect } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import { useLocation, useNavigate } from 'react-router-dom';
import "jarallax/dist/jarallax.css";
import "jarallax/dist/jarallax.min.js";
import "jarallax/dist/jarallax-element.min.js";

const ThankYouContent = () => {
  const location = useLocation();
  const { paymentRequestId, paymentStatus } = location.state || {};

  jarallaxElement();

  useEffect(() => {
    jarallax(document.querySelectorAll(".jarallax"));
  }, []);
  return (
    <section aria-label="section" className="no-top">
      <div className="container">
        <div className="thank-you-details">
          {paymentRequestId && (
            <p><strong>Payment Request ID:</strong> {paymentRequestId}</p>
          )}
          {paymentStatus && (
            <p><strong>Payment Status:</strong> {paymentStatus}</p>
          )}
        </div>
        <div className="thank-you-message">
          <h1>Thank You for Booking with Us!</h1>
          <p>
            Your appointment has been successfully confirmed. We are excited to
            have you at The Cutting Bar!
          </p>
          <p>
            Our team is looking forward to providing you with the best service.
          </p>
          <div className="cta-buttons">
            {/* <Link to="/" className="button">Back to Home</Link>
                <Link to="/my-appointments" className="button">View My Appointments</Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThankYouContent;
